const text = {
  es: {
    menu: {
      titol: 'Inicio',
      inici: 'Inicio',
      dashboard: 'Dashboard',
      informes: 'Informes',
      usuaris: 'Usuarios',
      clients: 'Clientes',
      parametresClients: 'Parámetros Clientes',
      informesConfig: 'Informes',
      configuracio: 'Configuración',
      descargarApp: 'Descargar app',
      conexions: 'Monitorización'
    },
    conexions: {
      titol: 'Conexiones',
      subtitol: 'Estado de conexión de los Hubs de cada cliente',
      cliente: 'Cliente',
      alias: 'Alias',
      estado: 'Estado',
      conectado: 'Conectado',
      desconectado: 'Desconectado',
      numConexiones: 'Nº conexiones',
      totalConexiones: 'clientes conectados',
      refrescar: 'Refrescar',
      errorLoad: 'Error al cargar las conexiones',
      empty: 'No hay clientes con Hub configurado',
      horaCache: 'Hora de precálculo',
      guardarHora: 'Guardar hora',
      horaGuardada: 'Hora guardada correctamente',
      errorGuardarHora: 'Error al guardar la hora',
      ejecutarAra: 'Ejecutar precálculo ahora',
      ejecucionLanzada: 'Precálculo lanzado en segundo plano',
      errorEjecutar: 'Error al lanzar el precálculo',
      ultimaEjecucion: 'Última ejecución',
      ok: 'OK',
      error: 'Error',
      sinConfigurar: 'Sin configurar',
      activo: 'Activo',
      inactivo: 'Inactivo',
      activarProgramacion: 'Activar/desactivar programación',
      eliminarProgramacion: 'Eliminar programación',
      confirmarEliminar: '¿Seguro que quieres eliminar la programación diaria de {nombre}? Se dejarán de precalcular sus consultas automáticamente.',
      eliminar: 'Eliminar',
      cancelar: 'Cancelar',
      programacionEliminada: 'Programación eliminada correctamente',
      errorEliminar: 'Error al eliminar la programación',

      // Version del exe del HUB
      monVersioHub: 'Version del HUB',
      monVersioHubHint: 'Exe que deben tener todos los clientes',
      verVersioActiva: 'Version activa',
      verPublicadaEl: 'Publicada el',
      verHubsAlDia: 'Hubs al dia',
      verHubsAlDiaHint: 'Ya ejecutan la version activa',
      verHubsEndarrerits: 'Hubs desactualizados',
      verHubsEndarreritsHint: 'Se actualizaran solos',
      verHubsDesconeguts: 'Sin reportar',
      verHubsDesconegutsHint: 'Todavia no han dicho que version llevan',
      verPublicarNova: 'Publicar una version nueva',
      verHistorial: 'Historial de versiones',
      verVersio: 'Version',
      verDesconeguda: 'Desconocida',
      verAlDia: 'Al dia',
      verEndarrerit: 'Desactualizado',
      verActiva: 'Activa',
      verCapPublicada: 'Ninguna version publicada',
      verNumero: 'Numero de version',
      verNotes: 'Notas',
      verNotesPlaceholder: 'Que hay de nuevo',
      verFitxer: 'Fichero .exe',
      verTriaFitxer: 'Elegir fichero...',
      verPujar: 'Publicar',
      verPujant: 'Subiendo...',
      verPujada: 'Version publicada. Los Hubs conectados ya han sido avisados.',
      verErrorPujar: 'Error al publicar la version',
      verData: 'Fecha',
      verMida: 'Tamano',
      verActivar: 'Volver a esta version',
      verActivada: 'Version activada',
      verConfirmarActivar: 'Volver a la version {version}? Todos los Hubs volveran solos. Es la forma de deshacer una version que ha salido mala.',
      verEsborrar: 'Borrar',
      verConfirmarEsborrar: 'Borrar la version {version} del servidor? Si algun dia quieres volver a ella, tendras que subirla de nuevo.',
      verAvis: 'Al publicar, todos los Hubs se descargaran este exe y se reiniciaran solos. Deja el numero de version igual que el de version.py.',

      // Monitorización y dimensionamiento del servicio
      monTitol: 'Monitorización',
      monSubtitol: 'Dimensionamiento del servicio y estado del hardware',
      monDimensionament: 'Dimensionamiento del servicio',
      monMaquinari: 'Hardware del servidor',
      monMaquinariHint: 'Indica si todavía se pueden subir los límites',
      monConnexions: 'Conexiones de los Hubs',
      monWorkers: 'Workers',
      monHubs: 'Hubs conectados',
      monRedis: 'Redis',
      monRedisActiu: 'Activo',
      monRedisInactiu: 'Inactivo',
      monMysqlAra: 'Conexiones MySQL ahora',
      monVariable: 'Variable',
      monValor: 'Valor actual',
      monRecomanat: 'Recomendado',
      monEstat: 'Estado',
      monIndicador: 'Indicador',
      monLlindar: 'Umbral',
      monTotCorrecte: 'Todo correcto',
      monCritics: 'críticos',
      monAvisos: 'avisos',
      monPerque: 'Por qué es importante',
      monCom: 'Cómo se modifica',
      monLoadAverage: 'Load average (1 / 5 / 15 min)',
      monNuclis: 'núcleos',
      monMemoria: 'Memoria',
      monSwap: 'Swap',
      monDisc: 'Disco',
      monLliures: 'libres',
      monErrorLoad: 'Error al cargar el dimensionamiento',
      monSensePermis: 'No tienes permisos para ver esta sección',
      monActualitzacions: 'Actualizaciones',
      monActualitzacionsHint: 'Vistas y funciones creadas en la base de datos de cada cliente',
      monClient: 'Cliente',
      monAlDia: 'al día',
      monAmbProblemes: 'con problemas',
      monActOk: 'Correctas',
      monActPendents: 'Pendientes',
      monUltimaExecucio: 'Última ejecución',
      monMai: 'Nunca',
      monExecutarAra: 'Ejecutar ahora',
      monReiniciar: 'Marcar para reejecutar',
      monReiniciarConfirm: 'Se marcarán TODAS las actualizaciones de este cliente para volver a aplicarlas, incluidas las que ya son correctas. ¿Quieres continuar?',
      monHubDesconnectat: 'El HUB no está conectado',
      monErrorActualitzacions: 'Error al cargar el estado de las actualizaciones',
      monExecutadesOk: 'Actualizaciones ejecutadas',
      monMarcadesOk: 'Actualizaciones marcadas para reejecutar',
      monSenseDetall: 'Ninguna actualización pendiente',
      monDesplega: 'Desplegar',
      monReplega: 'Replegar',
      monAlertaTitol: 'Rendimiento del servicio',
      monAlertaMissatge: 'El rendimiento del servicio está llegando al límite.',
      monAlertaCritic: 'Hay parámetros del servicio en estado crítico.',
      monAlertaAfectats: 'Parámetros afectados',
      monAlertaVeure: 'Ver el detalle',
      monAlertaMesTard: 'Ahora no',
      estatOk: 'OK',
      estatAvis: 'Aviso',
      estatCritic: 'Crítico',
      estatInfo: 'Info'
    },
    config: {
      titol: 'Configuración',
      cardTitle: 'Configuración',
      namePlaceholder: 'Nombre de la configuración',
      jsonPlaceholder: 'Ingrese el JSON de configuración',
      logoPlaceholder: 'Inserta imagen del logo',
      faviconPlaceholder: 'Inserta imagen del favicon',
      saveButton: 'Guardar',
      resetButton: 'Resetear',
      errorLoad: 'Error al cargar la configuración',
      successUpdated: 'Configuración actualizada',
      errorUpdate: 'Error al actualizar la configuración'
    },
    profile: {
      title: 'Mi Perfil',
      personalInfo: 'Información Personal',
      personalization: 'Personalización',
      language: 'Idioma',
      security: 'Seguridad',
      username: 'Nombre de usuario',
      fullName: 'Nombre completo',
      email: 'Correo electrónico',
      themeLabel: 'Tema de la consola',
      languageLabel: 'Idioma de la interfaz',
      currentThemeColors: 'Colores del tema actual',
      principal: 'Principal',
      secondary: 'Secundario',
      details: 'Detalles',
      headers: 'Headers',
      password: 'Contraseña',
      passwordDescription: 'Mantén tu cuenta segura actualizando tu contraseña regularmente.',
      changePassword: 'Cambiar',
      changeAvatar: 'Cambiar Avatar',
      avatarModalTitle: 'Cambiar Avatar',
      avatarUrlLabel: 'URL del avatar',
      avatarUrlPlaceholder: 'https://ejemplo.com/avatar.jpg',
      avatarUrlInfo: 'Introduce la URL de una imagen para actualizar tu avatar.',
      passwordModalTitle: 'Cambiar Contraseña',
      currentPassword: 'Contraseña actual',
      currentPasswordPlaceholder: 'Introduce tu contraseña actual',
      newPassword: 'Nueva contraseña',
      newPasswordLabel: 'Nueva contraseña',
      newPasswordPlaceholder: 'Introduce la nueva contraseña',
      confirmPassword: 'Confirmar nueva contraseña',
      confirmPasswordPlaceholder: 'Confirma la nueva contraseña',
      passwordRequirements: 'Requisitos de la contraseña',
      passwordMinLength: 'Al menos 8 caracteres',
      passwordUppercase: 'Una letra mayúscula (recomendado)',
      passwordNumber: 'Un número (recomendado)',
      passwordStrengthWeak: 'Débil',
      passwordStrengthMedium: 'Media',
      passwordStrengthGood: 'Buena',
      passwordStrengthExcellent: 'Excelente',
      save: 'Guardar',
      cancel: 'Cancelar',
      themeXperienceIQ: 'XperienceIQ',
      themeDark: 'Oscuro',
      themeSemiDark: 'Semi-oscuro',
      themeLight: 'Claro',
      themeXperienceIQDesc: 'Tema oficial de XperienceIQ',
      themeDarkDesc: 'Tema oscuro con tonos grises',
      themeSemiDarkDesc: 'Tema intermedio equilibrado',
      themeLightDesc: 'Tema claro y luminoso',
      languageSpanish: 'Español',
      languageCatalan: 'Català',
      languageSpanishDesc: 'Interfaz en español',
      languageCatalanDesc: 'Interfície en català',
      avatarUpdated: 'Avatar actualizado correctamente',
      avatarUpdateError: 'Error al actualizar el avatar',
      passwordUpdated: 'Contraseña actualizada correctamente',
      passwordUpdateError: 'Error al actualizar la contraseña',
      passwordMismatch: 'Las contraseñas no coinciden',
      themeUpdated: 'Tema actualizado correctamente',
      themeUpdateError: 'Error al actualizar el tema',
      languageUpdated: 'Idioma actualizado correctamente',
      languageUpdateError: 'Error al actualizar el idioma'
    },
    dashboard: {
      filterToday: 'Hoy',
      filterCurrentMonth: 'Mes actual',
      filterLast3Months: 'Últimos 3 meses',
      noClientTitle: 'Ningún cliente seleccionado',
      noClientSubtitle: 'Selecciona un cliente desde el menú lateral para visualizar su dashboard',
      noClientHint: 'Utiliza el selector de clientes del menú',
      clickForDetails: 'Clic para ver detalles',
      collaboratorsDetail: 'Detalle colaboradores',
      collaboratorColumn: 'Colaborador',
      productionColumn: 'Producción (€)',
      percentageColumn: 'Porcentaje (%)',
      totalLabel: 'Total:',
      distributionChart: 'Gráfico de distribución',
      tableTab: 'Tabla',
      chartTab: 'Gráfico',
      closeButton: 'Cerrar',
      monthlyComparison: 'Comparación mensual por colaborador',
      collaboratorsAxis: 'Colaboradores',
      productionAxis: 'Producción (€)'
    },
    appDownload: {
      title: 'Descargar App',
      subtitle: 'Descarga la aplicación móvil de XperienceIQ para acceder a todas las funcionalidades desde tu dispositivo',
      android: 'Android',
      ios: 'iOS',
      note: 'Los enlaces son de muestra. Reemplázalos con los enlaces reales de la tienda de aplicaciones.'
    }
  }
}
export default text
